import { z } from 'zod'

export const ADMINMCPSESSIONPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminMcpSessionPostResponseSchema = z.unknown()
export type AdminMcpSessionPostResponse = z.infer<typeof adminMcpSessionPostResponseSchema>
